import { IconButton } from '@csp/csp-web-ui';
import { FC } from 'react';
import { CloseButtonProps } from '../model/CloseButtonProps';

export const HeaderNavCloseButton: FC<CloseButtonProps> = ({ onCloseButtonClick }) => (
  <IconButton
    iconProps={{ name: 'close', size: 'large', color: 'black' }}
    onClick={onCloseButtonClick}
    aria-label="close"
    data-testid="header-nav-close-button"
  />
);
